/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_ByokInputs */

const tr_faq_a_byok = /** @type {(inputs: Faq_A_ByokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet. Ayarlar altındaki Yapay Zeka Sağlayıcısı sayfasında kendi API anahtarını girebilirsin. Kendi anahtarını kullandığında kredi harcamazsın, ücretler doğrudan sağlayıcına yansır. Bu özellik ileri düzey kullanıcılar içindir; kurulum adımlarını sayfada bulabilirsin.`)
};

const en_faq_a_byok = /** @type {(inputs: Faq_A_ByokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Enter your own key on the AI Provider page under Settings. Your own key means no credits are spent; charges go directly to your provider. Setup steps are on the page.`)
};

const de_faq_a_byok = /** @type {(inputs: Faq_A_ByokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Trage deinen eigenen Schlüssel auf der Seite KI-Anbieter unter Einstellungen ein. Mit eigenem Schlüssel verbrauchst du keine Credits - die Kosten gehen direkt an deinen Anbieter. Die Einrichtungsschritte findest du auf der Seite.`)
};

const ru_faq_a_byok = /** @type {(inputs: Faq_A_ByokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да. Введите свой ключ на странице Провайдер ИИ в Настройках. При использовании собственного ключа кредиты не расходуются, оплата идёт напрямую провайдеру.`)
};

/**
* | output |
* | --- |
* | "Yes. Enter your own key on the AI Provider page under Settings. Your own key means no credits are spent; charges go directly to your provider. Setup steps ar..." |
*
* @param {Faq_A_ByokInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_byok = /** @type {((inputs?: Faq_A_ByokInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_ByokInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_byok(inputs)
	if (locale === "de") return de_faq_a_byok(inputs)
	if (locale === "ru") return ru_faq_a_byok(inputs)
	return tr_faq_a_byok(inputs)
});